module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isolate) ? _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "header_margin"
  }, [_c('span', [_c('span', {
    staticClass: "site_label"
  }, [_vm._v("Isolate File Number")]), _vm._v(" "), _c('span', {
    staticClass: "site_value"
  }, [_vm._v("\n                " + _vm._s(_vm.isolate.isolateNumber) + "\n            ")])]), _vm._v(" "), (_vm.isolate.isolateCurationId) ? _c('span', [_c('span', {
    staticClass: "site_label"
  }, [_vm._v("Isolate Curation Number")]), _vm._v(" "), _c('span', {
    staticClass: "site_value"
  }, [_vm._v(_vm._s(_vm.isolate.isolateCurationId))])]) : _vm._e(), _vm._v(" "), (_vm.isolate.niRecId) ? _c('span', [_c('span', {
    staticClass: "site_label"
  }, [_vm._v("NIRecId (Legacy) ")]), _vm._v(" "), _c('span', {
    staticClass: "site_value"
  }, [_vm._v(_vm._s(_vm.isolate.niRecId))])]) : _vm._e(), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "site_label"
  }, [_vm._v("County")]), _vm._v(" "), _c('span', {
    staticClass: "site_value"
  }, [_vm._v("\n                " + _vm._s(_vm.isolate.countyCodeList) + "\n            ")])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-527bda01"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/IsolateHeader.vue
// module id = 939
// module chunks = 1